import { render, staticRenderFns } from "./rectSpin.vue?vue&type=template&id=b35b4c2c&scoped=true&"
import script from "./rectSpin.vue?vue&type=script&lang=js&"
export * from "./rectSpin.vue?vue&type=script&lang=js&"
import style0 from "./rectSpin.vue?vue&type=style&index=0&id=b35b4c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b4c2c",
  null
  
)

export default component.exports